import { WrapperComponents } from "../wrappers/WrapperComponents";
import { HeroSecondary } from "../headers/HeroSecondary";
import { CardMinimal } from "../components/cards/CardMinimal";
import { SectionGridCardTiles } from "../sections/grids/SectionGridCardTiles";
import { Filters } from "../elements/Filters";
import { LoaderDataPage } from "~/data/loaders/page";
import { type TemplateArchiveTeamLanding } from "~/sanity/types-mapped";
import { type QueryMembersStaticResult } from "~/sanity/types";
import { getPageSlug, truncate } from "~/styles/functions";
import { SectionGridArchive } from "../sections/grids/SectionGridArchive";
import { SectionBlockTextColumns } from "../sections/blocks/SectionBlockTextColumns";
import { SectionBlockPinnedMediaItems } from "../sections/blocks/SectionBlockPinnedMediaItems";
import { SectionCardCarousel } from "../sections/blocks/SectionCardCarousel";
import { CardCarousel } from "../components/cards/CardCarousel";

export interface ITemplateArchiveTeamLanding {
  data: Pick<LoaderDataPage, "members" | "membersCarousel" | "breadcrumbs"> &
    TemplateArchiveTeamLanding;
}

export default function TemplateArchiveTeamLanding({
  data,
}: ITemplateArchiveTeamLanding) {
  const {
    heroSecondary,
    breadcrumbs,
    sectionBlockTextColumns,
    sectionBlockPinnedMediaItems,
    membersCarousel,
    teamCarousel,
    teamArchive,
    members,
  } = data;

  // console.log(data);

  return (
    <>
      {heroSecondary && (
        <HeroSecondary data={heroSecondary} breadcrumbs={breadcrumbs} />
      )}
      <WrapperComponents>
        {sectionBlockTextColumns && (
          <SectionBlockTextColumns data={sectionBlockTextColumns} />
        )}

        {teamCarousel &&
          membersCarousel &&
          membersCarousel.items.length > 0 && (
            <SectionCardCarousel
              theme="colour"
              layout="small"
              data={{
                text: teamCarousel.description,
                title: teamCarousel.team?.title,
              }}
            >
              {Array.isArray(membersCarousel.items) &&
                membersCarousel.items.map((member: any, index: number) => (
                  <CardMinimal
                    key={index}
                    theme="light"
                    card={{
                      title: member.firstname + " " + member.lastname,
                      subtitle: member.role,
                      text: member.shortText,
                      link: member.slug
                        ? {
                            _type: "link",
                            type: "internal",
                            text: "View Profile",
                            slug: getPageSlug(
                              member.slug.current,
                              member._type,
                            ),
                          }
                        : undefined,
                      image: member.image,
                    }}
                  />
                ))}
            </SectionCardCarousel>
          )}

        {members && teamArchive && (
          <>
            <Filters
              items={members.items.length}
              pagination={members.pagination}
            >
              {Boolean(members.items.length) && (
                <SectionGridArchive title={teamArchive.title}>
                  {members.items.map((member, index) => {
                    return (
                      <CardMinimal
                        key={index}
                        card={{
                          title: member.firstname + " " + member.lastname,
                          subtitle: member.role,
                          text: member.shortText,
                          link:
                            member.text && member.shortText && member.slug
                              ? {
                                  _type: "link",
                                  type: "internal",
                                  text: "View Profile",
                                  slug: getPageSlug(
                                    member.slug.current,
                                    member._type,
                                  ),
                                }
                              : undefined,
                          image: member.image,
                        }}
                      />
                    );
                  })}
                </SectionGridArchive>
              )}
            </Filters>
          </>
        )}
        {sectionBlockPinnedMediaItems && (
          <SectionBlockPinnedMediaItems data={sectionBlockPinnedMediaItems} />
        )}
      </WrapperComponents>
    </>
  );
}
